<template>
  <div ref="layout" class="layout">
    <el-divider content-position="left">查询条件</el-divider>
    <el-form
      ref="form"
      size="small"
      label-width="120px"
      label-position="left"
      @submit.native.prevent
    >
      <el-form-item class="widget-view" label="生产计划类型" label-width="">
        <el-select
          v-model="conditions.wlyMakePlanOrderDanJuLeiXing"
          placeholder="请选择"
          type="select"
          size="mini"
          clearable
        >
          <el-option
            v-for="item in selectDataOptions['make_plan_type']"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item class="widget-view" label="营销单元" label-width="">
        <el-select
          v-model="conditions.wlyMakePlanOrderYingXiaoDanYuan"
          placeholder="请选择"
          type="select"
          size="mini"
          clearable
        >
          <el-option
            v-for="item in selectDataOptions['marketUnit']"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item class="widget-view" label="订单客户" label-width="">
        <el-input
          v-model="conditions.wlyMakePlanOrderDingDanKeHu"
          placeholder="请输入"
          type="text"
          size="mini"
          clearable
          @focus="getOrderCustomer"
        /></el-form-item>
      <el-form-item
        label="开票客户"
        label-width=""
      ><el-input
        v-model="conditions.wlyMakePlanOrderKaiPiaoKeHu"
        placeholder="请输入"
        type="text"
        size="mini"
        clearable
      /></el-form-item>
      <el-form-item
        class="widget-view"
        label="创建时间"
        label-width=""
      ><el-date-picker
        v-model="conditions.wlyMakePlanOrderCreateTime"
        type="date"
        value-format="yyyy-MM-dd"
        size="mini"
        format="yyyy-MM-dd"
        clearable
      /></el-form-item>
      <el-form-item
        class="widget-view"
        label="创建时间"
        label-width=""
      ><el-button
        type="primary"
        size="mini"
        @click="queryDataScjhcxtjPo"
      >查询</el-button></el-form-item>
    </el-form>
    <el-divider content-position="left">生产计划</el-divider>
    <div class="btky-container-crud__body">
      <vxe-grid
        ref="gridOptions_1tb13pp"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions_1tb13pp.gridOptions.columns"
        :data="gridOptions_1tb13pp.gridOptions.data"
      >
        <template
          v-if="gridOptions_1tb13pp.buttons && gridOptions_1tb13pp.buttons.length > 0"
          #form
        >
          <el-form class="form-btns">
            <el-button
              v-for="btn in gridOptions_1tb13pp.buttons"
              :key="btn.label"
              @click="tableEvent1tb13pp(btn)"
            >{{ btn.label }}</el-button>
          </el-form>
        </template>
        <template v-for="item in gridOptions_1tb13pp.gridOptions.columns" #[item.field]="{ row }">
          <div :key="item.field">
            <el-input
              v-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'input'"
              v-model="row[item.field]"
            />
            <el-select
              v-else-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'select'"
              v-model="row[item.field]"
              placeholder="请选择"
            >
              <el-option
                v-for="selectItem in gridOptions_1tb13pp.fields.options"
                :key="selectItem.val"
                :label="selectItem.label"
                :value="selectItem.val"
              />
            </el-select>
            <el-switch
              v-else-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'switch'"
              v-model="row[item.field]"
            />
            <el-radio-group
              v-else-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'radio'"
              v-model="row[item.field]"
            >
              <el-radio
                v-for="selectItem in gridOptions_1tb13pp.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-radio>
            </el-radio-group>
            <el-checkbox-group
              v-else-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'checkbox'"
              v-model="row[item.field]"
            >
              <el-checkbox
                v-for="selectItem in gridOptions_1tb13pp.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-checkbox>
            </el-checkbox-group>
            <!-- <el-checkbox v-else-if="gridOptions_1tb13pp.columnsFieldTypes[item.field] == 'checkbox'" v-model="row[item.field]">备选项</el-checkbox> -->
            <span v-else>{{ row[item.field] }}</span>
          </div>
        </template>
      </vxe-grid>
    </div>

    <el-divider content-position="left"> 汇总生产计划 </el-divider>

    <div class="btky-container-crud__body">
      <vxe-grid
        ref="gridOptions_07irttd"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions_07irttd.gridOptions.columns"
        :data="gridOptions_07irttd.gridOptions.data"
      >
        <template
          v-if="gridOptions_07irttd.buttons && gridOptions_07irttd.buttons.length > 0"
          #form
        >
          <el-form class="form-btns">
            <el-button
              v-for="btn in gridOptions_07irttd.buttons"
              :key="btn.label"
              @click="tableEvent07irttd(btn)"
            >{{ btn.label }}</el-button>
          </el-form>
        </template>
        <template v-for="item in gridOptions_07irttd.gridOptions.columns" #[item.field]="{ row }">
          <div :key="item.field">
            <el-input
              v-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'input'"
              v-model="row[item.field]"
            />
            <el-select
              v-else-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'select'"
              v-model="row[item.field]"
              placeholder="请选择"
            >
              <el-option
                v-for="selectItem in gridOptions_07irttd.fields.options"
                :key="selectItem.val"
                :label="selectItem.label"
                :value="selectItem.val"
              />
            </el-select>
            <el-switch
              v-else-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'switch'"
              v-model="row[item.field]"
            />
            <el-radio-group
              v-else-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'radio'"
              v-model="row[item.field]"
            >
              <el-radio
                v-for="selectItem in gridOptions_07irttd.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-radio>
            </el-radio-group>
            <el-checkbox-group
              v-else-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'checkbox'"
              v-model="row[item.field]"
            >
              <el-checkbox
                v-for="selectItem in gridOptions_07irttd.fields.options"
                :key="selectItem.val"
                :label="selectItem.val"
              >{{ selectItem.label }}</el-checkbox>
            </el-checkbox-group>
            <!-- <el-checkbox v-else-if="gridOptions_07irttd.columnsFieldTypes[item.field] == 'checkbox'" v-model="row[item.field]">备选项</el-checkbox> -->
            <span v-else>{{ row[item.field] }}</span>
          </div>
        </template>
      </vxe-grid>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :before-close="beforeClose"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="showDialogType === 'org'" ref="dialogEdit" />
        <product-select
          v-else-if="showDialogType === 'product'"
          ref="dialogEdit"
          :query-params="conditions"
        />
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>

    <!-- 页面通用弹窗情况 -->
    <el-dialog
      title="编辑"
      :visible.sync="showPageEditDialog"
      fullscreen
      :before-close="beforeClose"
      :append-to-body="true"
    >
      <!-- <sale-plan-edit v-if="showPageEditDialog && currentData.billType==='1' " :mode="mode" :row-data="currentData" @close="closePageEditDialog" />
      <sale-plan-change-edit v-if="showPageEditDialog && currentData.billType==='2' " :mode="mode" :row-data="currentData" @close="closePageEditDialog" /> -->
    </el-dialog>

  </div>
</template>
<script>
const dialogEdit = () => import('./dialogEdit.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

// import { apiDelInitById } from '@/api/materialInit'

// import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  components: {
    dialogEdit,
    OrgSelect,
    ProductSelect
  },
  data() {
    return {
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      showPageEditDialog: false,
      mode: 'edit',
      currentData: {},
      conditions: {
        wlyMakePlanOrderCreateTime: '',
        wlyMakePlanOrderKaiPiaoKeHu: '',
        wlyMakePlanOrderDingDanKeHu: '',
        wlyMakePlanOrderYingXiaoDanYuan: '',
        wlyMakePlanOrderDanJuLeiXing: ''
      },
      viewsConditions: {
        baseName: '',
        saleCenterName: ''
      },
      selectDataOptions: {},
      loading: false,
      gridOptions_1tb13pp: {
        default_value_type: 'fixed',
        required: false,
        hide_rights: false,
        read_rights: false,
        tableData: 'hzdcxcdscjhdPo',
        mode: 'block',
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '汇总',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '新增',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '编辑',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '删除',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        columns: [
          {
            label: '生产计划编号',
            popo: 'wlyMakePlanOrderOrderCode',
            id: '5e9b6bcc-8fd5-4e8f-9148-1cf5cacc9ad2'
          },
          {
            label: '产品编号',
            popo: 'wlyMakePlanDetailChanPinBianHao',
            id: '8d332ae1-a254-4dbd-ad1f-45277af4b0b4'
          },
          {
            label: '描述',
            popo: 'wlyMakePlanDetailMiaoShu',
            id: '9f3cce9c-f78b-4236-899a-25a6135a2c9a'
          },
          {
            label: '品牌',
            popo: 'wlyMakePlanDetailPinPai',
            id: 'fbaacab6-2253-493b-a03b-478e20e04c96'
          },
          {
            label: '开票客户名称',
            popo: 'wlyMakePlanOrderKaiPiaoKeHuName',
            id: '8cc13760-cbd3-404c-a8dc-0e41c56a50ee'
          },
          {
            label: '数量（件）',
            popo: 'wlyMakePlanDetailShuLiangJian',
            id: '88218383-a973-421c-9077-90c90452aee6'
          },
          {
            label: '数量（瓶）',
            popo: 'wlyMakePlanDetailShuLiangPing',
            id: '6e81467e-d8a0-4af8-bf2d-63e86835fc98'
          },
          {
            label: '数量（吨）',
            popo: 'wlyMakePlanDetailShuLiangDun',
            id: '1ec18797-e61d-49c1-954a-454d09f830ad'
          },
          {
            label: '区域',
            popo: 'wlyMakePlanDetailQuYu',
            id: 'efbb14a5-2f9a-48b4-a683-d967fa1373cd'
          },
          {
            label: '优先级',
            popo: 'wlyMakePlanDetailYouXianJi',
            id: '57efa45a-cd2b-4e5a-a4e6-16aa04e6e001'
          },
          {
            label: '状态',
            popo: 'wlyMakePlanOrderZhuangTai',
            id: 'f784e8d4-e3c3-4917-8208-7ec9d34b5d9b'
          },
          {
            label: '汇总单号',
            popo: 'wlyMakePlanSumHuiZongDanHao',
            id: '2504b65a-f232-4787-bbd0-36bfc41de5ec'
          },
          {
            label: '创建人',
            popo: 'wlyMakePlanOrderCreateBy',
            id: '1a1cdec9-c53b-4e94-a5e3-7dcf71d72a37'
          },
          {
            label: '创建时间',
            popo: 'wlyMakePlanOrderCreateTime',
            id: 'fcb18221-c600-4b05-a5a6-cac3ebdd57a5'
          }
        ],
        colspan: 4,
        summary: false,
        sum_text: '',
        summary_method: false,
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            { type: 'checkbox', title: 'id', filed: 'checkbox', width: 120 },
            {
              field: 'wlyMakePlanOrderOrderCode',
              title: '生产计划编号',
              slots: { default: 'wlyMakePlanOrderOrderCode' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailChanPinBianHao',
              title: '产品编号',
              slots: { default: 'wlyMakePlanDetailChanPinBianHao' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailMiaoShu',
              title: '描述',
              slots: { default: 'wlyMakePlanDetailMiaoShu' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailPinPai',
              title: '品牌',
              slots: { default: 'wlyMakePlanDetailPinPai' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanOrderKaiPiaoKeHuName',
              title: '开票客户名称',
              slots: { default: 'wlyMakePlanOrderKaiPiaoKeHuName' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanOrderCreateBy',
              title: '创建人',
              slots: { default: 'wlyMakePlanOrderCreateBy' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanOrderCreateTime',
              title: '创建时间',
              slots: { default: 'wlyMakePlanOrderCreateTime' },
              editRender: { name: 'input' }
            }
          ],
          data: [
            {
              wlyMakePlanOrderOrderCode: 1,
              wlyMakePlanDetailChanPinBianHao: 2,
              wlyMakePlanDetailMiaoShu: 3,
              wlyMakePlanDetailPinPai: 3,
              wlyMakePlanOrderKaiPiaoKeHuName: 4,
              wlyMakePlanOrderCreateBy: 5,
              wlyMakePlanOrderCreateTime: 6
            }
          ],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'default',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: { default: false },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'N'
      },
      gridOptions_07irttd: {
        default_value_type: 'fixed',
        required: false,
        hide_rights: false,
        read_rights: false,
        tableData: 'hzdcxcdscjhdPo',
        mode: 'block',
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '删除',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '确认',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        columns: [
          {
            label: '汇总单号',
            popo: 'wlyMakePlanSumHuiZongDanHao',
            id: '39ca683f-1604-47e3-b531-9e233c0b0434'
          },
          {
            label: '产品编号',
            popo: 'wlyMakePlanDetailChanPinBianHao',
            id: 'aed2c787-194d-4cbe-9185-91916f28407a'
          },
          {
            label: '品牌',
            popo: 'wlyMakePlanDetailPinPai',
            id: '04380e41-e82e-45cb-8ba2-90105824c79a'
          },
          {
            label: '描述',
            popo: 'wlyMakePlanDetailMiaoShu',
            id: 'c3c97886-810b-476b-ac25-55958741c483'
          },
          {
            label: '数量（件）',
            popo: 'wlyMakePlanDetailShuLiangJian',
            id: '558c14f7-c06e-46b9-b99e-53311ea16230'
          },
          {
            label: '数量（瓶）',
            popo: 'wlyMakePlanDetailShuLiangPing',
            id: '291ac875-ebdc-4851-8c17-e044dfa2a7b4'
          },
          {
            label: '数量（吨）',
            popo: 'wlyMakePlanDetailShuLiangDun',
            id: 'da7e1ba1-749f-4bec-a8a6-63ee52488bd5'
          },
          {
            label: '区域',
            popo: 'wlyMakePlanDetailQuYu',
            id: '274d5f42-b4cb-4050-af62-65e1ed67eb18'
          },
          {
            label: '优先级',
            popo: 'wlyMakePlanDetailYouXianJi',
            id: '9d75ec7c-f81a-42a0-9724-3bb9be8b8b8d'
          },
          {
            label: '状态',
            popo: 'wlyMakePlanOrderZhuangTai',
            id: 'bb91596c-fc90-4df2-86b0-859cda597435'
          },
          {
            label: '备注',
            popo: 'wlyMakePlanSumDBeiZhu',
            id: 'bf554c4a-1298-438b-a557-5589f7cf2ef4'
          }
        ],
        colspan: 4,
        summary: false,
        sum_text: '',
        summary_method: false,
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            { type: 'checkbox', title: 'id', filed: 'checkbox', width: 120 },
            {
              field: 'wlyMakePlanSumHuiZongDanHao',
              title: '汇总单号',
              width: 150,
              slots: { default: 'wlyMakePlanSumHuiZongDanHao' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailChanPinBianHao',
              title: '产品编号',
              width: 150,
              slots: { default: 'wlyMakePlanDetailChanPinBianHao' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailPinPai',
              title: '品牌',
              width: 150,
              slots: { default: 'wlyMakePlanDetailPinPai' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailMiaoShu',
              title: '描述',
              width: 150,
              slots: { default: 'wlyMakePlanDetailMiaoShu' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailShuLiangJian',
              title: '数量（件）',
              width: 150,
              slots: { default: 'wlyMakePlanDetailShuLiangJian' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailShuLiangPing',
              title: '数量（瓶）',
              width: 150,
              slots: { default: 'wlyMakePlanDetailShuLiangPing' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailShuLiangDun',
              title: '数量（吨）',
              width: 150,
              slots: { default: 'wlyMakePlanDetailShuLiangDun' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailQuYu',
              title: '区域',
              width: 150,
              slots: { default: 'wlyMakePlanDetailQuYu' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanDetailYouXianJi',
              title: '优先级',
              width: 150,
              slots: { default: 'wlyMakePlanDetailYouXianJi' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanOrderZhuangTai',
              title: '状态',
              width: 150,
              slots: { default: 'wlyMakePlanOrderZhuangTai' },
              editRender: { name: 'input' }
            },
            {
              field: 'wlyMakePlanSumDBeiZhu',
              title: '备注',
              width: 150,
              slots: { default: 'wlyMakePlanSumDBeiZhu' },
              editRender: { name: 'input' }
            }
          ],
          data: [],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'wlyMakePlanSumHuiZongDanHao',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: { default: false, wlyMakePlanSumHuiZongDanHao: false },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'N'
      }
    }
  },
  computed: {},
  created() {
    this.getSelectDictDataOrigin('make_plan_type')
    this.getSelectDictDataOrigin('marketUnit')
  },

  methods: {
    queryDataScjhcxtjPo() {
      const {
        wlyMakePlanOrderCreateTime,
        wlyMakePlanOrderKaiPiaoKeHu,
        wlyMakePlanOrderDingDanKeHu,
        wlyMakePlanOrderYingXiaoDanYuan,
        wlyMakePlanOrderDanJuLeiXing
      } = this.conditions
    },
    conditionsWlyMakePlanOrderDanJuLeiXingChanged(value) {
      this.$set(this['conditions'], 'wlyMakePlanOrderDanJuLeiXing', value)
    },

    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      // apiLoadDictionaryDtl(formData)
      //   .then(response => {
      //     this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
      //   })
      //   .catch(() => {})
    },
    handleSelectionChange1tb13pp(selection) {
      this.selection_1tb13pp = selection
    },
    tableEvent1tb13pp(btn) {
      const a = {
        wlyMakePlanOrderOrderCode: '',
        wlyMakePlanDetailChanPinBianHao: '',
        wlyMakePlanDetailMiaoShu: '',
        wlyMakePlanDetailPinPai: '',
        wlyMakePlanOrderKaiPiaoKeHuName: '',
        wlyMakePlanOrderCreateBy: '',
        wlyMakePlanOrderCreateTime: ''
      }
      switch (btn.label) {
        case '新增':
          this.gridOptions_1tb13pp.gridOptions.data.unshift(a)
          this.$refs.gridOptions_1tb13pp.insert(a)
          this.$refs.gridOptions_1tb13pp.setActiveRow(this.gridOptions_1tb13pp.gridOptions.data[0])
          break
        case '删除':
          this.$refs.gridOptions_1tb13pp.removeCheckboxRow()
          break
        case '编辑':
          this.$refs.gridOptions_1tb13pp.setActiveRow(
            this.$refs.gridOptions_1tb13pp.getCheckboxRecords()[0]
          )
          break
        case '保存':
          this.$refs.gridOptions_1tb13pp.clearActived().then(() => {})
          break
        case '导出':
          this.handleExport()
          break
        case '汇总':
          this.handleSum()
          break
      }
    },
    // 导出 下载
    async handleExport() {
      const params = {}
      const res = await apiDownload(params)
      if (res === null) return
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: res.headers['content-type'] })
      )
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', decodeURIComponent(res.headers['attachmentname']))
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    // 汇总
    handleSum() {},
    tableEvent07irttd(btn) {
      switch (btn.label) {
        case '新增':
          this.$refs.gridOptions_07irttd.insert({
            name: ''
          })
          break
        case '删除':
          this.$refs.gridOptions_07irttd.removeCheckboxRow()
          break
        case '编辑':
          this.$refs.gridOptions_07irttd.setActiveRow(
            this.$refs.gridOptions_07irttd.getCheckboxRecords()[0]
          )
          break
        case '保存':
          this.$refs.gridOptions_07irttd.clearActived().then(() => {})
          break
      }
    },
    // 打开窗口
    getOrderCustomer() {
      // this.$router.push({ name: 'Welcome', query: { id: 1 }, params: { dd: 2 }})
      this.showDialog = true
    },
    // 去订单详情
    goOrderDetail(row) {
      this.currentData = row
      this.showPageEditDialog = true
    },
    // 重置搜索
    resetQuery() {
      this.conditions = {
        province: '',
        city: '',
        base: '',
        saleCenter: '',
        salePerson: '',
        planCode: '',
        customerCode: '',
        customerType: ''
      }
      this.viewsConditions = {
        baseName: '',
        saleCenterName: ''
      }
      this.pagination.page = 1
    },
    // 弹窗关闭前操作
    beforeClose(done) {
      done()
    },
    // 打开窗口
    openSelectDialog(type) {
      this.showDialogType = type
      this.dialogTitle = {
        client: '客户选择',
        saleCenter: '营销单元选择',
        saleplan: '销售计划信息选择'
      }[type]
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(res => {
        console.log('submitForm', res)
        switch (this.showDialogType) {
          case 'base':
            this.conditions.base = res.code
            this.viewsConditions.baseName = res.code + '/' + res.name
            break
          case 'org':
            this.conditions.saleCenter = res.code
            this.viewsConditions.saleCenterName = res.code + '/' + res.name
            break
          case 'client':
            this.conditions.customerCode = res.customerCode
            break
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/demo/Test.vue